export default {
  data: () => ({
    mirrorFormOpen: false,
    mirrorFormReadonly: false,
    mirrorFormDuplicate: false,
    selectedMirror: null,

    commentFormOpen: false,
    commentTargetMirror: null,

    deleteDialog: false,
    deleteTarget: null,
    delMirrorLoading: false,

    disableDialog: false,
    disableTarget: null,
    disableMirrorLoading: false,

    geoListDialog: false,
    geoListTitle: '',
    geoListCountries: [],
    geoListKind: 'geo',
    geoListDefaultLocale: null,

    commentViewDialog: false,
    commentViewBody: '',

    featuresViewDialog: false,
    featuresViewTags: [],
    featuresViewMirrorId: null,
  }),
  methods: {
    openGeoListDialog({ title, countries }) {
      this.geoListTitle = title || ''
      this.geoListCountries = [...(countries || [])]
      this.geoListKind = 'geo'
      this.geoListDefaultLocale = null
      this.geoListDialog = true
    },
    openLocaleListDialog(item) {
      const hasLocales = item?.feature_config?.tags?.includes('locales')
      const source = hasLocales
        ? item?.feature_config?.config?.settings?.locales
        : this.project_config?.settings?.locales
      const def = source?.default ?? null
      this.geoListTitle = 'Language Locale'
      this.geoListCountries = [...this.mirrorLocales(item)]
      this.geoListKind = 'locale'
      this.geoListDefaultLocale = def
      this.geoListDialog = true
    },
    onGeoListDialogInput(open) {
      this.geoListDialog = open
      if (!open) {
        this.geoListTitle = ''
        this.geoListCountries = []
        this.geoListKind = 'geo'
        this.geoListDefaultLocale = null
      }
    },
    openCommentViewDialog(item) {
      this.commentViewBody = item?.settings?.comment ?? ''
      this.commentViewDialog = true
    },
    closeCommentViewDialog() {
      this.commentViewDialog = false
      this.commentViewBody = ''
    },
    onCommentViewDialogInput(open) {
      this.commentViewDialog = open
      if (!open) {
        this.commentViewBody = ''
      }
    },
    openFeaturesViewDialog(item) {
      const tags = item?.feature_config?.tags || []
      this.featuresViewTags = [...tags]
      this.featuresViewMirrorId = item?.mirror_id ?? null
      this.featuresViewDialog = true
    },
    closeFeaturesViewDialog() {
      this.featuresViewDialog = false
      this.featuresViewTags = []
      this.featuresViewMirrorId = null
    },
    onFeaturesViewDialogInput(open) {
      this.featuresViewDialog = open
      if (!open) {
        this.featuresViewTags = []
        this.featuresViewMirrorId = null
      }
    },
    navigateToFeatureConfigForMirror() {
      if (this.featuresViewMirrorId == null || this.project == null) return
      const mirrorId = this.featuresViewMirrorId
      this.closeFeaturesViewDialog()
      this.goToFeatureConfigMirror(mirrorId)
    },
    openDeleteDialog(item) {
      this.deleteTarget = item || null
      this.deleteDialog = true
    },
    closeDeleteDialog() {
      if (this.delMirrorLoading) return
      this.deleteDialog = false
      this.deleteTarget = null
    },
    openDisableDialog(item) {
      this.disableTarget = item || null
      this.disableDialog = true
    },
    closeDisableDialog() {
      if (this.disableMirrorLoading) return
      this.disableDialog = false
      this.disableTarget = null
    },
    openMirrorForm(mirror = null, { readonly = false, duplicate = false } = {}) {
      this.selectedMirror = mirror || null
      this.mirrorFormReadonly = readonly
      this.mirrorFormDuplicate = duplicate
      this.mirrorFormOpen = true
    },
    closeMirrorForm(close = false) {
      if (this.mirrorSaveLoading && !close) return
      this.mirrorFormOpen = false
      this.mirrorFormReadonly = false
      this.mirrorFormDuplicate = false
      this.selectedMirror = null
    },
    openCommentForm(mirror = null) {
      this.commentTargetMirror = mirror || null
      this.commentFormOpen = true
    },
    closeCommentForm(close = false) {
      if (this.mirrorSaveLoading && !close) return
      this.commentFormOpen = false
      this.commentTargetMirror = null
    },
  },
}
